import React, { useEffect, useMemo, useState } from 'react';
import { App, Spin } from 'antd';
import useMyEquipoComponentsApi from 'pages/liftlogic/v2/Components/useMyEquipoComponentsApi';
import useTenantComponentCatalogApi from 'pages/liftlogic/v2/Components/useTenantComponentCatalogApi';
import ComponentInstanceTree from 'pages/liftlogic/v2/Components/ComponentInstanceTree';

function ComponentesEquipo({ idEquipo }) {
  const raw = useMyEquipoComponentsApi();
  const catalog = useTenantComponentCatalogApi();
  const { message } = App.useApp();
  const [canEdit, setCanEdit] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const p = await raw.getPermissions();
        if (on) setCanEdit(!!p.canEdit);
      } catch (e) {
        message.error('No se pudieron cargar permisos');
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => {
      on = false;
    };
  }, [raw, message]);

  const api = useMemo(
    () => ({
      getTree: (eq) => raw.getTree(eq),
      addNode: (eq, p) => raw.addNode(eq, p),
      updateNode: (n, p) => raw.updateNode(n, p),
      removeNode: (n) => raw.removeNode(n),
      cloneTemplate: (eq, r) => raw.cloneTemplate(eq, r),
      replaceComponent: (nodeId, p) => raw.replaceComponent(idEquipo, nodeId, p),
      listReplacements: (nodeId) => raw.listReplacements(idEquipo, nodeId),
    }),
    [raw, idEquipo]
  );

  // typesApi adaptado para que tenga el método list() esperado por ComponentInstanceTree.
  const typesApi = useMemo(() => ({ list: catalog.listTypes }), [catalog]);

  if (loading) return <Spin />;
  return (
    <ComponentInstanceTree
      api={api}
      defsApi={catalog}
      templatesApi={catalog}
      typesApi={typesApi}
      canEdit={canEdit}
      equipoId={idEquipo}
    />
  );
}

export default ComponentesEquipo;
